import {
  styled,
  TextField,
  IconButton,
  Paper,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Box,
  Tab,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./gallery.css";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Event1 from "../../../images/event1.jpg";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import SearchBar from "../../../components/SearchBox/searchbox.js";
import { Form } from "antd";
import getEventController from "../Controller/getEvent_controller.js";
import { Button } from "react-bootstrap";
// import MyDocument from "../../Admin/pdf/individual-membership-cert.tsx";
import { pdf, PDFDownloadLink } from "@react-pdf/renderer";
// import MyDocument2 from "../../Admin/pdf/corporate-membership-cert.tsx";

const Gallery = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const isLargeScreen = useMediaQuery("(min-width:640px)");

  const [spacing, setSpacing] = React.useState(2);
  const [form] = Form.useForm();
  const [eventCategoriesData, seteventCategoriesData] = useState([]);

  // Sample events array with image and title data
  const galleries = [
    // {
    //   imgSrc: Event1,
    //   title: "SHOPPING MALL MANAGEMENT CONTINUOUS EDUCATION SEMINARS (SMMCES)",
    // },
    // { imgSrc: Event1, title: "ANOTHER EVENT TITLE" },
  ];

  useEffect(() => {
    getEventController
      .getEventCategoriesforPhotoGallery()
      .then((response) => {
        console.log("API Response:", response); // Debugging log

        if (Array.isArray(response)) {
          // Ensure response is an array
          seteventCategoriesData(response);
        } else {
          console.error("API response is not an array:", response);
          seteventCategoriesData([]); // Set empty array to prevent .map() errors
        }
      })
      .catch((error) => {
        console.error("Error fetching event categories:", error);
        seteventCategoriesData([]); // Handle errors gracefully
      });
  }, []);

  const handleEventClick = (eventCategoryId) => {
    if (eventCategoryId === 20) {
      window.open(
        "https://www.ppkm.org.my/site/ppkm-awards-gallery/",
        "_blank"
      ); // Open in a new tab
    } else {
      navigate("/gallery_details", { state: { eventCategoryId } }); // Navigate normally
    }
  };

  // const handlePreview = async () => {
  //   // Generate the PDF as a Blob
  //   const blob = await pdf(<MyDocument />).toBlob();

  //   // Create a URL for the Blob
  //   const url = URL.createObjectURL(blob);

  //   // Open the URL in a new tab
  //   window.open(url, "_blank");
  // };

  // const handlePreview2 = async () => {
  //   // Generate the PDF as a Blob
  //   const blob = await pdf(<MyDocument2 />).toBlob();

  //   // Create a URL for the Blob
  //   const url = URL.createObjectURL(blob);

  //   // Open the URL in a new tab
  //   window.open(url, "_blank");
  // };

  return (
    <React.Fragment>
      {!isLargeScreen ? (
        <div className="gallery-list">
          {/*Search Bar */}
          <div className="row-1 ">
            <Grid className="sec_grid" container spacing={2}>
              <Grid size={12}>
                <TextField
                  className="searchbar"
                  label="Search"
                  variant="outlined"
                  size="small"
                  slotProps={{
                    input: {
                      endAdornment: (
                        <IconButton
                          type="button"
                          aria-label="search"
                          size="small"
                        >
                          <SearchIcon />
                        </IconButton>
                      ),
                    },
                  }}
                />
              </Grid>
            </Grid>
          </div>
          {/*Gallery Grid*/}
          <div className="document-row">
            <Grid container spacing={2} sx={{ justifyContent: "center" }}>
              {galleries.slice(0, 4).map((event, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={index}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Paper
                    sx={(theme) => ({
                      display: "flex",
                      height: 300,
                      width: 250,
                      marginTop: "20px",
                      backgroundColor: "#fff",
                      ...theme.applyStyles("dark", {
                        backgroundColor: "#1A2027",
                      }),
                      boxShadow: 5,
                      justifyContent: "center",
                      alignItems: "center",
                    })}
                    onClick={() => navigate("/gallery_details")}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        fontSize: "12px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      <img
                        src={event.imgSrc}
                        alt={event.title}
                        className="upcoming-event-icon"
                      />
                      <span>{event.title}</span>
                    </div>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </div>
        </div>
      ) : (
        <div className="gallery-list">
          <div className="gallery-title">Photo Gallery</div>
          {/* <button onClick={handlePreview}>Preview PDF</button>
          <button onClick={handlePreview2}>Preview PDF2</button> */}
          {/*Search Bar */}
          {/* <SearchBar /> */}
          {/*Gallery Grid*/}
          <div className="document-row">
            <Grid
              container
              spacing={2}
              sx={{ justifyContent: "center", margin: "10px" }}
            >
              {eventCategoriesData.map((event, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Form form={form} component={false}>
                    <Paper
                      sx={(theme) => ({
                        display: "flex",
                        flexDirection: "column", // Stack items vertically
                        alignItems: "center", // Center content
                        height: "250px",
                        width: "450px",
                        marginTop: "20px",
                        backgroundColor: "#fff",
                        ...theme.applyStyles("dark", {
                          backgroundColor: "#1A2027",
                        }),
                        boxShadow: 5,
                        justifyContent: "center", // Center content inside
                        border: "2px solid #b24743",
                        borderRadius: "15px",
                        cursor: "pointer",
                        transition: "transform 0.3s ease-in-out",
                        "&:hover": {
                          transform: "scale(1.03)",
                          boxShadow: 10,
                        },
                      })}
                      onClick={() => handleEventClick(event.event_categoryID)}
                    >
                      <div
                        className="col-md-12"
                        style={{
                          display: "flex",
                          flexDirection: "column", // Stack items vertically
                          alignItems: "center",
                          padding: "10px",
                          textAlign: "center",
                          height: "100px",
                        }}
                        id={event.id}
                      >
                        {/* Event Category Title */}
                        <span className="event-category-title">
                          {event.event_category_name}
                        </span>
                      </div>
                      {/* Button Wrapper (Separate div for better positioning) */}
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            width: "80%", // Make button longer
                            padding: "10px",
                            backgroundColor: "#b24743",
                            color: "white",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "16px",
                            fontWeight: "bold",
                            transition: "background-color 0.3s",
                          }}
                        >
                          View Gallery
                        </button>
                      </div>
                    </Paper>
                  </Form>
                </Grid>
              ))}
            </Grid>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Gallery;
